import React from 'react';
import '../assets/styles/MunicipioLayout.scss';
import Alcaldia from '../components/municipalidad/Alcaldia';

const AlcaldiaCont = () => (
  <div className='MainMunicipio'>
    <Alcaldia />
  </div>
);
export default AlcaldiaCont;
